'use strict';

window.dndNextLevel = window.dndNextLevel || {};
dndNextLevel.oneShot = dndNextLevel.oneShot || {};

dndNextLevel.oneShot.allowExpectedErrorSwap = function (event) {
    const expectedErrorStatuses = [400, 409];
    if (!expectedErrorStatuses.includes(event.detail.xhr.status)) {
        return;
    }

    event.detail.shouldSwap = true;
    event.detail.isError = false;
};

dndNextLevel.oneShot.alignBossMonsterReference = function () {
    const dungeonRow = document.querySelector?.('.one-shot-history-row--dungeon');
    const bossEncounter = dungeonRow?.querySelector('[data-action="focus-boss-statblock-trigger"]');
    const monsterReference = dungeonRow?.querySelector('[data-role="boss-monster-reference"]');
    const openButton = dungeonRow?.querySelector(
        '[data-role="boss-monster-reference"] [data-action="open-monster-reference"]'
    );

    if (!monsterReference) {
        return;
    }

    const desktopLayout = !window.matchMedia || window.matchMedia('(min-width: 1024px)').matches;
    monsterReference.style.marginTop = '';
    if (!desktopLayout || !bossEncounter || !openButton) {
        return;
    }

    const offset = bossEncounter.getBoundingClientRect().top - openButton.getBoundingClientRect().top;
    if (offset > 0) {
        monsterReference.style.marginTop = offset + 'px';
    }
};

dndNextLevel.oneShot.scheduleBossMonsterReferenceAlignment = function () {
    if (window.requestAnimationFrame) {
        window.requestAnimationFrame(dndNextLevel.oneShot.alignBossMonsterReference);
        return;
    }
    dndNextLevel.oneShot.alignBossMonsterReference();
};

dndNextLevel.oneShot.handleBossEncounterClick = function (event) {
    const bossEncounter = event.target.closest?.('[data-action="focus-boss-statblock-trigger"]');
    if (!bossEncounter) {
        return false;
    }

    event.preventDefault();
    const dungeonRow = bossEncounter.closest('.one-shot-history-row--dungeon');
    const openButton = dungeonRow?.querySelector(
        '[data-role="boss-monster-reference"] [data-action="open-monster-reference"]'
    );
    openButton?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
    });
    openButton?.focus({preventScroll: true});
    return true;
};

dndNextLevel.oneShot.setActionStatus = function (message, isError = false) {
    const status = document.querySelector?.('#one-shot-action-status');
    if (!status) return;
    status.textContent = message;
    status.dataset.state = isError ? 'error' : 'success';
};

dndNextLevel.oneShot.copyOutline = async function () {
    const recent = dndNextLevel.oneShotRecentAdapter;
    const snapshot = recent?.captureDocument(document);
    if (!snapshot || !window.navigator?.clipboard?.writeText) {
        dndNextLevel.oneShot.setActionStatus('Copy is unavailable for this session.', true);
        return false;
    }
    try {
        await window.navigator.clipboard.writeText(recent.formatOutline(snapshot));
        dndNextLevel.oneShot.setActionStatus('One-Shot outline copied.');
        return true;
    } catch (_error) {
        dndNextLevel.oneShot.setActionStatus('Copy failed. Check browser clipboard permission.', true);
        return false;
    }
};

dndNextLevel.oneShot.saveSnapshot = function () {
    const recent = dndNextLevel.oneShotRecentAdapter;
    const snapshot = recent?.captureDocument(document);
    const saved = snapshot ? recent.saveCurrent(snapshot, window.localStorage, true) : null;
    dndNextLevel.oneShot.setActionStatus(
        saved ? 'One-Shot snapshot saved to Recent.' : 'This session could not be saved.',
        !saved
    );
    return saved;
};

dndNextLevel.oneShot.printSession = function () {
    const disclosures = Array.from(document.querySelectorAll?.(
        '#one-shot-history [data-component="one-shot-stage-disclosure"]'
    ) || []);
    const openState = disclosures.map(disclosure => disclosure.open);
    disclosures.forEach(disclosure => { disclosure.open = true; });
    window.print?.();
    disclosures.forEach((disclosure, index) => { disclosure.open = openState[index]; });
};

dndNextLevel.oneShot.startNewSession = function () {
    if (!window.confirm?.('Start a new One Shot? This replaces the active server session.')) {
        return false;
    }
    document.querySelector?.('#actionUrl')?.requestSubmit?.();
    return true;
};

dndNextLevel.oneShot.returnToActiveSession = function () {
    const snapshot = document.querySelector?.('#one-shot-read-only-snapshot');
    const workspace = document.querySelector?.('#one-shot-workspace');
    if (!snapshot || !workspace) return false;
    snapshot.hidden = true;
    workspace.hidden = false;
    return true;
};

dndNextLevel.oneShot.handleWorkspaceAction = function (event) {
    const trigger = event.target.closest?.('[data-action]');
    const action = trigger?.dataset?.action;
    if (!action) return false;
    if (action === 'copy-one-shot') {
        event.preventDefault();
        dndNextLevel.oneShot.copyOutline();
        return true;
    }
    if (action === 'save-one-shot') {
        event.preventDefault();
        dndNextLevel.oneShot.saveSnapshot();
        return true;
    }
    if (action === 'print-one-shot') {
        event.preventDefault();
        dndNextLevel.oneShot.printSession();
        return true;
    }
    if (action === 'new-one-shot') {
        event.preventDefault();
        dndNextLevel.oneShot.startNewSession();
        return true;
    }
    if (action === 'return-to-active-one-shot') {
        event.preventDefault();
        dndNextLevel.oneShot.returnToActiveSession();
        return true;
    }
    return false;
};

dndNextLevel.oneShot.restoreQueuedSnapshot = function () {
    const recent = dndNextLevel.oneShotRecentAdapter;
    const payload = recent?.consumeRestore?.();
    return payload ? recent.renderReadOnly(payload, document) : false;
};

dndNextLevel.oneShot.bindEvents = function () {
    if (dndNextLevel.oneShot.eventsBound) {
        return;
    }

    document.addEventListener('htmx:beforeSwap', dndNextLevel.oneShot.allowExpectedErrorSwap);
    document.addEventListener('htmx:afterSwap', dndNextLevel.oneShot.scheduleBossMonsterReferenceAlignment);
    document.addEventListener('htmx:afterSettle', dndNextLevel.oneShot.scheduleBossMonsterReferenceAlignment);
    document.addEventListener('click', event => {
        if (dndNextLevel.oneShot.handleWorkspaceAction(event)) {
            return;
        }
        if (dndNextLevel.oneShot.handleBossEncounterClick(event)) {
            return;
        }
    });
    window.addEventListener?.('resize', dndNextLevel.oneShot.scheduleBossMonsterReferenceAlignment);
    dndNextLevel.oneShot.eventsBound = true;
    dndNextLevel.oneShot.restoreQueuedSnapshot();
    dndNextLevel.oneShot.scheduleBossMonsterReferenceAlignment();
};

dndNextLevel.oneShot.bindEvents();
